/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    scope_inbox_id,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        scope_inbox_id,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getConversationMetric(type = 'account', page = 1, scope_inbox_id) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
        scope_inbox_id,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/agents`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getConversationTrafficCSV(scope_inbox_id) {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset(), scope_inbox_id },
    });
  }

  getLabelReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/labels`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getInboxReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getTeamReports({ from: since, to: until, businessHours }) {
    return axios.get(`${this.url}/teams`, {
      params: { since, until, business_hours: businessHours },
    });
  }

  getBotMetrics({ from, to, scope_inbox_id } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to, scope_inbox_id: scope_inbox_id },
    });
  }

  getBotSummary({ from, to, groupBy, businessHours, scope_inbox_id } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
        scope_inbox_id,
      },
    });
  }

  getBotIntents({ from, to, inbox_id, page, per_page } = {}) {
    return axios.get(`${this.url}/bot_intents`, {
      params: {
        since: from,
        until: to,
        inbox_id: inbox_id,
        page: page,
        per_page: per_page,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getBotIntentReports({
    from,
    to,
    inbox_id,
    intent_id,
    page = 1,
    per_page = 10,
  } = {}) {
    return axios.get(`${this.url}/bot_intent_reports`, {
      params: {
        since: from,
        until: to,
        inbox_id: inbox_id,
        intent_id: intent_id,
        page: page,
        per_page: per_page,
        timezone_offset: getTimeOffset(),
      },
    });
  }

  getBotIntentMetrics({
    from,
    to,
    inbox_id,
    intent_id,
    page = 1,
    per_page = 10,
  } = {}) {
    return axios.get(`${this.url}/bot_intent_metrics`, {
      params: {
        since: from,
        until: to,
        inbox_id: inbox_id,
        intent_id: intent_id,
        page: page,
        per_page: per_page,
        timezone_offset: getTimeOffset(),
      },
    });
  }
}

export default new ReportsAPI();
